import { ReactNode } from "react";
import { Provider } from "react-redux";
import itemsControlStore, { ItemsControlContext } from "./store";

interface IProps {
    appID?: string;
    children: ReactNode;
}

function ItemsControlProvider(props: IProps) {
    return (
        <Provider store={itemsControlStore} context={ItemsControlContext}>
            {props.children}
        </Provider>
    );
}

export default ItemsControlProvider;
